/**
 * @generated SignedSource<<5958f544fbab836e104daa0da8396741>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicCollectionRestContentsCollection$data = {
  readonly advertZone: string | null | undefined;
  readonly entityId: string;
  readonly " $fragmentType": "topicCollectionRestContentsCollection";
};
export type topicCollectionRestContentsCollection$key = {
  readonly " $data"?: topicCollectionRestContentsCollection$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicCollectionRestContentsCollection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicCollectionRestContentsCollection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "version",
          "value": 2
        }
      ],
      "kind": "ScalarField",
      "name": "advertZone",
      "storageKey": "advertZone(version:2)"
    }
  ],
  "type": "Collection",
  "abstractKey": null
};

(node as any).hash = "1985f2555f33fd312d6a32c22927926d";

export default node;
